import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonInput, IonModal } from '@ionic/angular';
import { ColumnMode, SelectionType, SortType, DatatableComponent } from '@swimlane/ngx-datatable';
import { DataService } from 'src/app/data.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import moment from 'moment';
import { fromEvent } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-szamla',
  templateUrl: './szamla.component.html',
  styleUrls: ['./szamla.component.scss'],
})
export class SzamlaComponent implements OnInit {

  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;
  protected readonly JSON = JSON;

  sajatIntezmeny
  intezmeny = 2
  dolgozok = 0
  tanulok = 0
  felulet = 0
  import = 0
  besorolas = 0
  enaplo = 0
  dokumentumok = 0
  adatszolg = 0
  penzugy = 0
  modulok = 0
  munkatarssorok = [];
  datetime
  alkalmazk
  alkalmazv

  selected = [];
  telepules
  allampolgar
  orszag
  SelectionType = SelectionType;
  allomany
  csoport
  @ViewChild("uzenetmodal") modal: IonModal;
  @ViewChild("bizonylatmodal") bizmodal: IonModal;
  segment = "1"
  bizonylattipus = 0;
  bizonylatok = ["-", "számla", "előleg számla", "díjbekérő", "nyugta", "árajánlat", "szállítólevél", "teljesítésigazolás"]
  invoices
  filteredInvoices = []
  // Azok a díjbekérő-id-k, amelyekhez már tartozik aktív (nem storno) végszámla → rendezettnek számítanak.
  settledProformaIds = new Set<string>();
  loginmode

  /*  CSALÁDI NÉZET: gondviselő VAGY a saját nevében belépő tanuló.
   *
   *  A pénzügy a CSALÁD nyilvántartása. A tanulói belépést eddig semmi nem
   *  kezelte, ezért mindenhol az „egyébként" ág futott – az intézményi nézet,
   *  adminisztrátori műveletekkel. Egy helyen dől el, hogy ki számít családnak.
   */
  get csaladiNezet(): boolean {
    return this.loginmode === 'gondviselo' || this.loginmode === 'tanulo';
  }
  lathatNav = false;
  lathatCashbook = false;
  stornozhat = false;
  userMetadata
  stornoTarget

  // ─────────────────────────── Szűrőpanel ───────────────────────────
  // Kliens-oldali szűrés: a bizonylatok egyben betöltődnek, a szűrők élőben (Alkalmaz gomb
  // nélkül) számítják a `filteredInvoices` listát, amit a táblázat mutat.
  showFilters = false;
  filter = {
    search: '',
    dateFrom: '',
    dateTo: '',
    dateField: 'created_at',            // melyik dátumra vonatkozik az időszak (Kiállítás/Teljesítés/Határidő)
    status: { fizetett: false, esedekes: false, lejart: false, nemfiz: false },
    tipus: {} as { [k: string]: boolean },
    tomb: '',
    fizmod: '',
    csalad: '',                         // egy család / vevő összes bizonylata
  };
  // A típus-fajták definíciója (kód → megnevezés + ikon). A szűrőben csak a ténylegesen
  // előforduló típusok jelennek meg, hogy ne legyen zsúfolt.
  tipusDefs = [
    { k: '1', nev: 'Számla', icon: 'assets/icon/icons8-invoice-96.png' },
    { k: '2', nev: 'Előleg számla', icon: 'assets/icon/icons8-proforma-invoice-80.png' },
    { k: '3', nev: 'Díjbekérő', icon: 'assets/icon/icons8-message-96.png' },
    { k: '4', nev: 'Nyugta', icon: 'assets/icon/icons8-receipt-96.png' },
    { k: '5', nev: 'Árajánlat', icon: 'assets/icon/icons8-clipboard-96.png' },
    { k: '6', nev: 'Szállítólevél', icon: 'assets/icon/icons8-delivery-96.png' },
    { k: '7', nev: 'Teljesítésigazolás', icon: 'assets/icon/icons8-task-completed-96.png' },
    { k: '8', nev: 'Storno számla', icon: 'assets/icon/icons8-shredder-96.png' },
    { k: '9', nev: 'Módosító számla', icon: 'assets/icon/icons8-proforma-invoice-80.png' },
    { k: '10', nev: 'Számviteli bizonylat', icon: 'assets/icon/icons8-general-ledger-96.png' },
  ];
  tombLista: { id: string; elotag: string }[] = [];
  fizmodLista: string[] = [];
  jelenlevoTipusok = new Set<string>();
  // Statisztikák a szűrt találatokra
  statDb = 0;
  statBrutto = 0;
  statKintlevo = 0;


  public currentPageLimit: number = 10;
  public currentVisible: number = 10;
  @ViewChild(DatatableComponent) public table: DatatableComponent;
  public column = [{ name: 'Name' }, { name: 'Gender' }, { name: 'Company' }];
  public readonly pageLimitOptions = [
    { value: 5 },
    { value: 10 },
    { value: 25 },
    { value: 50 },
    { value: 100 },
  ];
  public readonly visibleOptions = [
    { value: 1 },
    { value: 3 },
    { value: 5 },
    { value: 10 },
  ];

  portControl: FormControl;
  form: FormGroup;
  @ViewChild('search', { static: false }) search: any;

  constructor(private http: HttpClient, private data: DataService,
    private formBuilder: FormBuilder) {
    this.portControl = this.formBuilder.control(
      { id: 142, nev: "magyar" },
      Validators.required
    );
    this.form = this.formBuilder.group({
      anyanyelv: this.portControl,
      allampolgar1: this.portControl,
      allampolgar2: this.portControl,
      alkalmazk: new FormControl("", Validators.required),
      alkalmazv: new FormControl(""),
      orszag: new FormControl({ id: 142, nev: "Magyarország" }, Validators.required)
    });
  }

  // Melyik fizetési szolgáltató gombját mutassuk (adminban állítható: Stripe / OTP
  // SimplePay / mindkettő). Alapértelmezés a régi Stripe.
  fizetesMod: any = { szolgaltato: 'stripe', stripe: true, simple: false };

  /** Nincs elérhető fizetőkapu ennek a felhasználónak (kikapcsolva vagy próbaüzem). */
  get nincsFizetokapu(): boolean {
    return !this.fizetesMod?.stripe && !this.fizetesMod?.simple;
  }

  /*  PRÓBAÜZEM: a fizetőoldal új fülben nyílik, ahol nincs belépési jegy. Ezért előbb
   *  kérünk egy rövid életű, adminhoz kötött kulcsot, és azzal nyitjuk meg. */
  /*  FIZETŐ-JEGY: a SimplePay a BELÉPETT felhasználó adataival (név, e-mail, cím) induljon,
   *  ne a díjbekérő címzettjéével – több bizonylat egyszerre is fizethető, és a címzettnek
   *  nem mindig van rögzített címe. Az új fülön nincs belépési jegy, ezért előbb kérünk egy
   *  rövid életű kulcsot (backend/checkout-simple.js › /fizeto-jegy). */
  private async fizetoToldat(): Promise<string> {
    try {
      const r: any = await this.http.get('/api/simplepay/fizeto-jegy').toPromise();
      return r?.kulcs ? `&fizeto=${encodeURIComponent(r.kulcs)}` : '';
    } catch (e) { return ''; }
  }

  private async probaToldat(): Promise<string> {
    if (!this.fizetesMod?.probauzem) return '';
    try {
      const iid = this.sajatIntezmeny?.intezmenyId || '';
      const r: any = await this.http
        .get(`/api/simplepay/proba-jegy?intezmeny=${encodeURIComponent(iid)}`).toPromise();
      return r?.kulcs ? `&proba=${encodeURIComponent(r.kulcs)}` : '';
    } catch (e) { return ''; }
  }

  async fizetesMegnyit(bizid: any, mod: 'stripe' | 'simple') {
    const ablak = (window as any).Capacitor?.isNativePlatform?.() ? null : window.open('about:blank', '_blank');   // azonnal (mobil felugró-tiltás)
    const toldat = await this.probaToldat() + (mod === 'simple' ? await this.fizetoToldat() : '');
    const alap = mod === 'simple' ? '/api/simplepay/form?id=' : '/api/checkout/form?id=';
    const cel = `${alap}${encodeURIComponent(bizid)}${toldat}`;
    if (ablak) ablak.location.href = cel; else window.open(cel, '_blank');
  }

  async loadFizetesMod() {
    try {
      const iid = encodeURIComponent(this.sajatIntezmeny?.intezmenyId || '');
      const r: any = await this.http.get(`/api/simplepay/status?intezmeny=${iid}`).toPromise();
      if (r && !r.error) this.fizetesMod = r;
    } catch (e) { /* marad a Stripe */ }
    this.loadFizetesFeldolgozas()
  }

  // Már kifizetett, de még nem könyvelt bizonylatok: itt a fizetés gomb tiltva marad,
  // hogy ne induljon második fizetés ugyanarra a számlára.
  fizetesFeldolgozas = new Set<string>();

  async loadFizetesFeldolgozas() {
    try {
      const iid = encodeURIComponent(this.sajatIntezmeny?.intezmenyId || '');
      const r: any = await this.http.get(`/api/simplepay/folyamatban?intezmeny=${iid}`).toPromise();
      /*  KÉT KÜLÖN ÁLLAPOT (javítás, 2026-10-08). Eddig a már KIFIZETETT és lekönyvelt bizonylat
       *  is a „feldolgozás alatt” halmazba került, így a sikeres fizetés után örökre a sárga,
       *  pörgő gomb maradt rajta. A kifizetett zöld „Kifizetve” jelet kap (újra fizetni így sem
       *  lehet), a sárga csak a megérkezett, de még le nem könyvelt fizetésé. */
      this.fizetesFeldolgozas = new Set<string>(r?.bizidk || []);
      this.marKifizetett = new Set<string>(r?.kifizetett || []);
    } catch (e) { this.fizetesFeldolgozas = new Set<string>(); this.marKifizetett = new Set<string>(); }
  }

  marKifizetett = new Set<string>();

  feldolgozasAlatt(bizid: any) {
    return !!bizid && this.fizetesFeldolgozas.has(String(bizid));
  }

  kifizetve(bizid: any) {
    return !!bizid && this.marKifizetett.has(String(bizid)) && !this.fizetesFeldolgozas.has(String(bizid));
  }

  /** Van-e már a bizonylaton fizetés (feldolgozás alatt vagy kifizetve) – ilyenkor nincs fizetés gomb. */
  fizetesLezarva(bizid: any) {
    return this.feldolgozasAlatt(bizid) || this.kifizetve(bizid);
  }

  async ngOnInit() {
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    this.loginmode = (await this.data.getFromStorage("loginmode"))

    // Lapon belüli műveletek jogosultsága (Jogosultságok szerkesztő, „Műveletek" csoport).
    // Korábban ezek is a bejelentkezési módra voltak drótozva.
    const jog = await this.data.hozzaferesek();
    this.lathatNav = jog.szabad('/penzugy/szamla#nav');
    this.lathatCashbook = jog.szabad('/penzugy/szamla#cashbook');
    this.stornozhat = jog.szabad('/penzugy/szamla#storno');
    this.loadFizetesMod()
    if (this.csaladiNezet)
      this.userMetadata = await this.data.getFromStorage("userMetadata")

    this.getAllomany();

    fromEvent(this.search.nativeElement, 'keydown')
      .pipe(
        debounceTime(550),
        map(x => x['target']['value'])
      )
      .subscribe(value => {
        //this.updateFilter(value);
        //console.log(value)
      });
  }




  public onLimitChange(limit: any): void {
    limit = limit.target.value
    this.changePageLimit(limit);
    this.table.limit = this.currentPageLimit;
    this.table.recalculate();
    setTimeout(() => {
      if (this.table.bodyComponent.temp.length <= 0) {
        // TODO[Dmitry Teplov] find a better way.
        // TODO[Dmitry Teplov] test with server-side paging.
        this.table.offset = Math.floor((this.table.rowCount - 1) / this.table.limit);
        // this.table.offset = 0;
      }
    });
  }

  public onVisibleChange(visible: any): void {
    visible = visible.target.value
    this.currentVisible = parseInt(visible, 10);
  }

  private changePageLimit(limit: any): void {
    this.currentPageLimit = parseInt(limit, 10);
  }


  getRowClass = (row) => {
    return {
      'row-color-blue': row.priority == 1,
      'row-color-green': row.priority == 2,
      'row-color-orange': row.priority == 3,
      'row-color-red': row.priority == 4,
    };
  }

  initModal(id) {
    this.form.patchValue({ orszag: { id: 1, nev: "Afganisztán" } })
    this.modal.present();
  }
  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  getEletut() {
    this.http
      .get(
        'https://merfoldkovek.oh.gov.hu/api/User/Timeline',
        {

        }
      )
      .subscribe({
        next: (response) => {
          //this.allomany = response
          console.log(response)
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          /*
          {
              "allapot": "NincsMegFeliratkozva",
              "formatumVerzio": 1,
              "generalva": "0001-01-01T00:00:00",
              "adatok": null,
              "adatAllapot": "OsszeallitasAlatt",
              "leiratkozasOka": "Oktazonvaltozas",
              "leiratkozva": null,
              "letrehozva": null,
              "megtekintveUgyintezokent": false,
              "ugyintezoOktazon": null,
              "isSucceeded": true,
              "reasonOfFail": null,
              "muveletAzonosito": "67155014-3c68-47cc-802d-a68aee09ce1c",
              "errorCode": 0,
              "errorCodeString": "0000",
              "time": "2025-01-17T16:35:45.4874766+01:00"
          } */
        },
      });
  }

  getAllomany() {
    let headers = {
      intezmeny: this.sajatIntezmeny.intezmenyId
    }
    let csaladbeszur = ""
    if (this.csaladiNezet) csaladbeszur = "csalad"
    this.http
      .get(
        '/api/szamla/bizonylatok' + csaladbeszur + '/' + (this.csaladiNezet ? this.userMetadata.username : this.sajatIntezmeny.intezmenyId),
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response: any) => {
          this.invoices = Array.isArray(response) ? response : []
          // Mely díjbekérőkhöz (proforma) tartozik már aktív (nem storno) végszámla → azok rendezettek.
          this.settledProformaIds = new Set(
            this.invoices
              .filter(f => Number(f.tipus) === 1 && Number(f.storno) !== 1 && f.proforma_id)
              .map(f => String(f.proforma_id))
          );
          this.invoices.forEach(f => this.szamolStatus(f));
          this.buildFacets();
          this.buildCsaladFacet();
          this.applyFilters();
          // console.log(this.allomany)
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/szulo/' + this.sajatIntezmeny.intezmenyId,
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.allomany = response
          console.log(this.allomany)
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/csoport/' + this.sajatIntezmeny.intezmenyId,
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.csoport = response
          console.log(this.csoport)
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/telepules/hu',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.telepules = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/allampolgarsag',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.allampolgar = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
    this.http
      .get(
        '/api/nyilvantartas/orszagok',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.orszag = response
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
  }



  // Számla fizetési státusza.
  //  - storno (tipus 8) és mínuszos bizonylat (pl. visszatérítő módosító): 'nf' = nem fizetendő
  //    (sosem fizetjük be, a határidő nem számít).
  //  - pluszos módosító (tipus 9, osszesen>0) és sima számla: normál státusz.
  szamolStatus(f) {
    if (Number(f.tipus) === 8 || Number(f.osszesen) < 0) {
      f.status = 'nf';
      return;
    }
    // Díjbekérő (tipus 3), amelyből már készült aktív végszámla → rendezve (nem "esedékes").
    if (Number(f.tipus) === 3 && this.settledProformaIds.has(String(f.id))) {
      f.status = 1;
      return;
    }
    f.status = '-2';
    (f.tranzakciok || []).forEach(g => {
      if (g.paid == true) f.status = 1;
    });
    if (f.status == '-2') {
      f.mennyinap = moment(f.fiz_hat).diff(moment(new Date()), "days") || 0;
      if (moment(f.fiz_hat).format("YYYY-MM-DD") >= moment(new Date()).format("YYYY-MM-DD")) {
        f.status = '0';
      } else f.status = '-1';
    }
  }

  cancel() {
    this.modal.dismiss(null, 'cancel');
  }

  confirm(mode) {
    this.bizmodal.dismiss(null, 'ok');
    this.bizonylattipus = mode;
    this.modal.present();
  }

  selectChangedAnyanyelv(e) {

  }

  public alertButtons = [
    {
      text: 'Mégse',
      role: 'cancel',
      handler: () => {
        //console.log('Alert canceled');
      },
    },
    {
      text: 'Igen',
      role: 'confirm',
      handler: () => {
        //console.log('Alert confirmed');
      },
    },
  ];
  /**
   *  A bizonylat PDF-jének újragenerálása a tárolt adatokból (aláírással – e-számlánál láthatóan).
   *  Akkor kell, ha a PDF hiányzik, aláíratlan maradt, vagy a bizonylat adata utólag változott
   *  (pl. fizetettre állítás). A NAV-hoz nem nyúl.
   */
  pdfUjraFut: Record<string, boolean> = {};
  async pdfUjra(row: any) {
    if (!confirm('Újrageneráljuk a bizonylat PDF-jét a tárolt adatokból (aláírással)?')) return;
    this.pdfUjraFut[row.id] = true;
    this.http.get('/api/nav/geninvoice/' + row.id + '/' + this.sajatIntezmeny.intezmenyId).subscribe({
      next: () => { this.pdfUjraFut[row.id] = false; this.data.sendToast('A PDF újragenerálva.', 'success'); },
      error: (e) => { this.pdfUjraFut[row.id] = false; this.data.sendToast(e?.error?.error || 'A PDF újragenerálása nem sikerült.', 'error'); },
    });
  }

  async stornoSzamla(e) {
    if (e.detail.role != "confirm") return;
    const target = this.stornoTarget;
    if (!target) return;

    await this.data.showLoading("Bizonylat stornózása...")
    const intezmeny = this.sajatIntezmeny.intezmenyId;
    this.http
      .post('/api/nav/storno/' + target.id + '/' + intezmeny, {})
      .subscribe({
        next: (response: any) => {
          this.data.hideLoading();
          if (response.status == "OK") {
            if (response.navbekuldve === false) {
              this.data.sendToast("Storno bizonylat elkészült, de a NAV beküldés nem sikerült (később automatikusan újrapróbáljuk).", "warning")
            } else {
              this.data.sendToast("Bizonylat stornózva!", "success")
            }
            this.getAllomany();
          } else {
            this.data.sendToast(response.error || "Bizonylat stornózása sikertelen!", "error")
          }
          this.stornoTarget = null;
        },
        error: (error) => {
          this.data.hideLoading();
          console.error('Error storno:', error);
          this.data.sendToast("Bizonylat stornózása sikertelen!", "error")
          this.stornoTarget = null;
        },
      });
  }

  // ─────────────────────────── Szűrő-logika ───────────────────────────

  // A vevő megjelenítendő neve: partner (ha partneres bizonylat), különben a szülő neve.
  vevoNev(row: any): string {
    const partner = (row?.partner_nev || '').trim();
    if (partner) return partner;
    const szulo = `${row?.vez || ''} ${row?.ker || ''}`.trim();
    return szulo;
  }

  // A szűrő-lenyílók lehetőségei az adatból (előforduló bizonylattömbök, fizetési módok, típusok).
  /** A bizonylatokon előforduló címzettek (család / partner) – a szűrő-lenyílóhoz. */
  csaladLista: any[] = [];

  private buildCsaladFacet() {
    const map = new Map<string, string>();
    for (const row of (this.invoices || []) as any[]) {
      const kulcs = String(row.kapja || row.partner_id || '').trim();
      if (!kulcs) continue;
      const nev = this.vevoNev(row) || kulcs;
      if (!map.has(kulcs)) map.set(kulcs, nev);
    }
    this.csaladLista = [...map].map(([id, nev]) => ({ id, nev }))
      .sort((a, b) => a.nev.localeCompare(b.nev, 'hu'));
  }

  buildFacets() {
    const tm = new Map<string, string>();
    const fm = new Set<string>();
    this.jelenlevoTipusok = new Set<string>();
    (this.invoices || []).forEach((r: any) => {
      if (r.tomb != null && r.tomb !== '') tm.set(String(r.tomb), r.elotag || String(r.tomb));
      if (r.fiz_mod) fm.add(r.fiz_mod);
      if (r.tipus != null) this.jelenlevoTipusok.add(String(r.tipus));
    });
    this.tombLista = Array.from(tm, ([id, elotag]) => ({ id, elotag }))
      .sort((a, b) => String(a.elotag).localeCompare(String(b.elotag), 'hu'));
    this.fizmodLista = Array.from(fm).sort((a, b) => a.localeCompare(b, 'hu'));
  }

  // A megjelenítendő típus-szűrők (csak amelyik előfordul; ha üres, mind).
  get tipusValaszthato() {
    if (!this.jelenlevoTipusok.size) return this.tipusDefs;
    return this.tipusDefs.filter(t => this.jelenlevoTipusok.has(t.k));
  }

  // Élő szűrés: minden szűrőmező-változás ezt hívja.
  applyFilters() {
    const f = this.filter;
    const search = (f.search || '').toLowerCase().trim();
    const statusAktiv = Object.values(f.status).some(Boolean);
    const tipusAktiv = Object.values(f.tipus).some(Boolean);
    const from = f.dateFrom || '';
    const to = f.dateTo || '';

    this.filteredInvoices = (this.invoices || []).filter((row: any) => {
      // Szabadszavas keresés: sorszám + vevő/partner név
      if (search) {
        const hay = `${row.szamlaszam || ''} ${this.vevoNev(row)}`.toLowerCase();
        if (hay.indexOf(search) === -1) return false;
      }
      // Fizetési státusz (több is választható – VAGY kapcsolat)
      if (statusAktiv) {
        const s = String(row.status);
        const ok =
          (f.status.fizetett && s === '1') ||
          (f.status.esedekes && s === '0') ||
          (f.status.lejart && s === '-1') ||
          (f.status.nemfiz && s === 'nf');
        if (!ok) return false;
      }
      // Bizonylat típusa (több is választható – VAGY kapcsolat)
      if (tipusAktiv && !f.tipus[String(row.tipus)]) return false;
      // Bizonylattömb
      if (f.tomb && String(row.tomb) !== String(f.tomb)) return false;
      // Fizetési mód
      if (f.fizmod && (row.fiz_mod || '') !== f.fizmod) return false;
      // Család / vevő: a címzett azonosítója szerint (a névazonosság félrevinne).
      if (f.csalad && String(row.kapja || row.partner_id || '') !== String(f.csalad)) return false;
      // Időszak – a kiválasztott dátummezőre (Kiállítás/Teljesítés/Határidő)
      if (from || to) {
        const raw = row[f.dateField];
        if (!raw) return false;
        const d = moment(raw).format('YYYY-MM-DD');
        if (from && d < from) return false;
        if (to && d > to) return false;
      }
      return true;
    });

    // Statisztikák a szűrt találatokra
    this.statDb = this.filteredInvoices.length;
    this.statBrutto = this.filteredInvoices.reduce((sum: number, r: any) => sum + (Number(r.osszesen) || 0), 0);
    this.statKintlevo = this.filteredInvoices
      .filter((r: any) => String(r.status) === '0' || String(r.status) === '-1')
      .reduce((sum: number, r: any) => sum + (Number(r.osszesen) || 0), 0);
  }

  // Egy fizetési-státusz gomb ki/be kapcsolása (pill).
  toggleStatus(kulcs: 'fizetett' | 'esedekes' | 'lejart' | 'nemfiz') {
    this.filter.status[kulcs] = !this.filter.status[kulcs];
    this.applyFilters();
  }

  // Egy típus-pill ki/be kapcsolása.
  toggleTipus(k: string) {
    this.filter.tipus[k] = !this.filter.tipus[k];
    this.applyFilters();
  }

  // Időszak alapja (melyik dátummező) váltás.
  setDateField(mezo: string) {
    this.filter.dateField = mezo;
    this.applyFilters();
  }

  // Aktív szűrők száma (a "Szűrők" gomb badge-éhez és a törlés láthatóságához).
  aktivSzurokSzama(): number {
    const f = this.filter;
    let n = 0;
    if (f.search) n++;
    if (f.dateFrom || f.dateTo) n++;
    n += Object.values(f.status).filter(Boolean).length;
    n += Object.values(f.tipus).filter(Boolean).length;
    if (f.tomb) n++;
    if (f.fizmod) n++;
    if (f.csalad) n++;
    return n;
  }

  // Minden szűrő nullázása.
  resetFilters() {
    this.filter = {
      csalad: '',
      search: '',
      dateFrom: '',
      dateTo: '',
      dateField: 'created_at',
      status: { fizetett: false, esedekes: false, lejart: false, nemfiz: false },
      tipus: {},
      tomb: '',
      fizmod: '',
    };
    this.applyFilters();
  }
}
